import type { AuthenticatedPageProps, UnauthenticatedPageProps } from "@/types";
import { usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";

const useCurrentRoute = () => {
	const [currentRoute, setCurrentRoute] = useState<string | undefined>(
		undefined,
	);

	const { ziggy } = usePage<UnauthenticatedPageProps | AuthenticatedPageProps>()
		.props;

	useEffect(() => {
		const parsedUrl = new URL(ziggy.location);
		setCurrentRoute(parsedUrl.pathname);
	}, [ziggy]);

	return currentRoute;
};

export default useCurrentRoute;
